define('models/Patient',[
	'core/can', 
	'models/Session', 
	'models/Base',
	'models/Cached',
	'models/Address',
	'models/Eligibility'
], function(can, Session, Base, Cached, Address, Eligibility) {
	
	// This can be deprecated if the API returns an object that 
	// follows the existing model's definition.
	var Name = Cached.extend({
		findAll: 'GET /Patient/Names'
	},{
		_Name: can.compute(function() {
			if (this.attr('LastName') && this.attr('FirstName')) {
				return this.attr('LastName') + ', ' + this.attr('FirstName');
			} else {
				return this.attr('LastName') || this.attr('FirstName') || undefined;
			}
		})
	});
	
	Name.List.prototype.comparator = 'LastName';
	
/*
	var Insured = Base.extend({
		
		// EntityId
		// Address
		// Name
		// DOB
		// Gender
		// InsuredType
		// SequenceNumber
		// PayerId
		// SubscriberId
		// EmployerName
		// GroupName
		// PlanName
		// HicNumber
		// PlanId
		// GroupNumber
		// AssignmentOfBenefitsCertIndicator
		// PatientRelationshipToInsured
		// CreatedOn
		// CreatedBy
		// ModifiedOn
		// ModifiedBy
	
		_InsuredType: can.compute(function() {
			switch (this.attr(InsuredType)) {
				case 0: return 'Medicare';
				case 1: return 'Commercial';
			}
		})
	});
*/
		
	var Patient = Base.extend({

		findAll: 'GET /Patient/List',
		findOne: 'GET /Patient/{id}',
		create:  'POST /Patient',
		update:  'PUT /Patient',
		// destroy: 'DELETE /Patient/{id}'
		// search:  'GET /Patient/Search/{providerId}/{searchString}'
		
	},{
	
		define: {
			ProviderId: {
				value: function() {
					// TODO is this good?
					if (!Session.attr('_isVendor') && Session.attr('Providers.length') === 1) {
						return Session.attr('Providers.0._id');
					}
				}	
			},
			Name: {
				value: {} // TODO Name Map?
			},
			Address: {
				Type: Address,
				value: {}
			},
			Gender: { 
				type: 'number',
				value: 2
			},

			/*InsuredList: {
				Type: Insured.List
			},*/

			Eligibility: {
				Type: Eligibility
			}
		},
		
		_Name: can.compute(function() {
			if (this.attr('Name.Last') && this.attr('Name.First')) {
				return this.attr('Name.Last') + ', ' + this.attr('Name.First');
			} else {
				return this.attr('Name.Last') || this.attr('Name.First') || undefined;
			}
		}),
		
		_Gender: can.compute(function() {
			switch (this.attr('Gender')) {
				case 0: return 'Male';
				case 1: return 'Female';
				default:
				case 2: return 'Unknown';
			}
		}),
		
		_MaritalStatus: can.compute(function() {
			switch (this.attr('MaritalStatus')) {
				default:
				case 0: return 'Other';
				case 1: return 'Married';
				case 2: return 'Single';
			}
		}),
		
		_EmploymentStatus: can.compute(function() {
			switch (this.attr('EmploymentStatus')) {
				default:
				case 0: return 'None';
				case 1: return 'Employed';
				case 2: return 'Full Time Student';
				case 3: return 'Part Time Student';
			}
		}),
		
		// Medicare Helpers
		
		_HIC: can.compute(function() {
			return this.attr('_Medicare.SubscriberId'); 
		}),
		
		_Medicare: can.compute(function() {
			this.attr('Insureds').filter(function(insured) {
				return insured.attr('InsuredType') === 0;
			});
		}),
		
		createEligibility: function() {
			return new Eligibility({
				SearchNpi:				Session.attr('Providers').attr('0.Npi'),
				SearchPtan:				Session.attr('Providers').attr('0.Ptan'),
				PatientId: 				this.attr('_id'),
				SearchHicNumber: 		this.attr('HicNumber'),
				SearchLastName: 		this.attr('Name.Last'),
				SearchFirstInitial: 	this.attr('Name.First'),
				SearchDOB: 				this.attr('DOB'),
				SearchGender: 			this.attr('Gender'),
				Status: 				1
			}).toUpperCase(['SearchLastName', 'SearchFirstInitial']);
		}
	});
	
	Patient.prototype.rules = {
		'ProviderId': {
			validators: {
				notEmpty: {
					message: 'Provider is required.'
				}
			}
		},
		'Name.First': {
			validators: {
				notEmpty: {
					message: 'First Name is required.'
				}
			}
		},
		'Name.Last': {
			validators: {
				notEmpty: {
					message: 'Last Name is required.'
				}
			}
		},
		HicNumber: {
			validators: {
				notEmpty: {
					message: 'Medicare Record Number is required.'
				}
			}
		},
		// PatientControlNumber
		DOB: {
			validators: {
				notEmpty: {
					message: 'Date of Birth is required.'
				},
				date: {
                    message: 'Date of Birth must be a valid date.'
                }
			}
		},
		Gender: {
			validators: {
				notEmpty: {
					message: 'Gender is required.'
				}
			}
		},
		'Address.Line1': {
			validators: {
				notEmpty: {
					message: 'Line 1 is required.'
				}
			}
		},
		// AddressLine2
		'Address.City': {
			validators: {
				notEmpty: {
					message: 'City is required.'
				}
			}
		},
		'Address.State': {
			validators: {
				notEmpty: {
					message: 'State is required.'
				}
			}
		},
		'Address.ZipCode': {
			validators: {
				notEmpty: {
					message: 'Zip is required.'
				}
			}
		}
	};
	
	// Patient.List.prototype.comparator = 'Name.Last';
	
	Patient.Name = Name;
	
	return Patient;
	
});
